import Api from '~/api'
import { Map, List, fromJS } from 'immutable'
import { registerEvents } from '~/event/actions'

export function updateInterviewStatus(interview_id, status) {
  return async dispatch => {
    try {
      dispatch({
        type: 'INTERVIEW_STATUS_LOADING',
        interview_id,
        loading: true,
      })

      let { data } = await Api.patch(`/interview/${interview_id}/status`, { status })

      dispatch(registerEvents(data.events))

      if (data.success) {
        dispatch({
          type: 'INTERVIEW_STATUS_SUCCESS',
          interview_id,
          table_id: 'interviews',
          item: data.item,
        })
      } else {
        throw Error(data.message)
      }
    } catch (err) {
      console.log(err)
      dispatch({
        type: 'INTERVIEW_STATUS_ERROR',
        message: err.message || 'Error when updating status',
        interview_id,
      })
    }
  }
}
